import {CtModelRouteData} from "@ctsolution/ct-framework";

export const ContactRouteData = (): CtModelRouteData => CtModelRouteData
  .create()
  .setController("contact");
